module.exports = __webpack_public_path__ + "media/images/icons/twotone/left-square-ee4b9d2fdc8df035b3d97eb7feba8cc5.svg";